import { createSlice } from '@reduxjs/toolkit'

export const phoneBookInfo = createSlice({
  name: 'phoneBookInfo',
  initialState: {},
  reducers: {
    setPhoneBookInfo: (state, action) => {
      return action.payload
    },
  },
})

export const { setPhoneBookInfo } = phoneBookInfo.actions
